import React, { useState, useEffect, useRef } from 'react'
import { Modal, Form, Select, Input, Button, message, Switch, DatePicker, Alert, Space, Typography, Spin } from 'antd'
import { PlusCircleOutlined, SaveOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { sendDataBody, updateData } from '../../resources';

// admin and receipt shares create-cita, hospital-tab.citas and create-cita-for-medic
// ONLY RECEIPT CANT DELETE, SO, FIRST EDIT RECEIPTIONIST

export function CreateCitaForm(props) {

    const [medicos, setMedicos] = useState([])
    const [servicios, setServicios] = useState([])
    const [pacientes, setPacientes] = useState([])
    const [pacientesLoading, setPacientesLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const [enableCreateCita, setEnableCreateCita] = useState(true)

    const editInitialized = useRef(false)
    const searchDebounce = useRef(null)

    const fetchPacientes = (search = "") => {
        setPacientesLoading(true)
        sendDataBody('pacientes/medicos/search/name', { medicos: props.idsMedicos, search })
            .then(data => {
                data.forEach(p => { p.label = p.name; p.value = p._id })
                setPacientes(data)
                if (props.cita?.usuario && !editInitialized.current) {
                    editInitialized.current = true
                    const patient = data.find(p => p._id === props.cita.usuario)
                    if (patient) handlePatientChange(props.cita.usuario, patient)
                }
            })
            .finally(() => setPacientesLoading(false))
    }

    useEffect(() => {
        console.log('Received Cita for edit', props.cita)
        fetchPacientes()
    }, [])

    useEffect(() => {
        if (props.cita && props.cita.medico) handleMedicochange(props.cita.medico)
    }, [medicos])


    // Form Methods
    const onFinish = (values) => {
        if (medicos.length === 1) values.medico = medicos[0]._id
        values.sucursal = props.hospital;
        delete values.tratamiento;
        values.id_servicio = values.servicio.key;
        values.servicio = values.servicio.label;
        delete values.tipo_pago;

        console.log('cita ready', values)
        if (props.cita) {
            updateData(`citas/update/${props.cita._id}`, values).then((response) => {
                props.setIsModalOpen(false);
                props.setEditingCita(false);
            }).finally(() => { props.getCitasData(); })
        } else {
            sendDataBody('citas/add', values).then((response) => {
                message.success(response.message || response.error);
            }).finally(() => { props.getCitasData(); props.setIsModalOpen(false) })
        }
    }

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    const handlePatientChange = (value, option) => {
        if (option) {
            setEnableCreateCita(true)
            let { medicos_asignados } = option
            medicos_asignados.forEach((m) => { m.label = m.name; m.value = m._id })
            setMedicos(medicos_asignados)

            if (medicos_asignados.length === 1) {
                if (medicos_asignados[0].configuracion && medicos_asignados[0].configuracion.tratamientos_ofrecidos) {
                    const tratamientos = medicos_asignados[0].configuracion.tratamientos_ofrecidos;
                    tratamientos.forEach(t => {
                        t.key = t._id; t.label = `${t.tratamiento} - ${t.observaciones ?? ""}`; t.value = t.costo + "-" + t._id; t.title = t.tratamiento;
                    });
                    setServicios(tratamientos)
                } else {
                    setErrorMessage("No se puede crear la cita para este médico, no cuenta con servicios")
                }
            }
        } else {
            setEnableCreateCita(false)
            setErrorMessage("Usuario no encontrado")
        }
    }

    const handleMedicochange = (_id) => {
        console.log('selected', _id)
        console.log('all medics handle med chang', medicos)
        if (medicos.length > 0) {
            let found = medicos.find((m) => m._id === _id)
            if (found && found.configuracion.tratamientos_ofrecidos) {
                setErrorMessage("")
                setEnableCreateCita(true)
                if (props.enableCreateCita) props.setEditingCita(false)
                let { configuracion: { tratamientos_ofrecidos } } = found;
                console.log("found tr", tratamientos_ofrecidos)
                tratamientos_ofrecidos.forEach(t => {
                    t.key = t._id; t.label = `${t.tratamiento} - $${t.costo} - ${t.observaciones ?? ""}`; t.value = t.costo + "-" + t._id; t.title = t.tratamiento;
                });
                setServicios(tratamientos_ofrecidos)
            } else {
                setEnableCreateCita(false);
                setErrorMessage("No se puede crear la cita para este médico, no cuenta con servicios")
                if (props.enableCreateCita) props.enableCreateCita(false)
            }
        }
    }

    const onSwitch = (checked) => { };

    const handleServicioChange = (selected) => {
        var cobro = selected.value.split("-")[0];
        console.log(`selected service`, selected);
        console.log(`selected cobro`, cobro);
    };

    const timeOptions = [
        { label: 'Media Hora', value: 30 },
        { label: 'Una Hora', value: 60 },
        { label: 'Una Hora y Media', value: 90 },
        { label: 'Dos Horas', value: 120 },
        { label: 'Dos Horas Y Media', value: 150 },
        { label: 'Tres Horas', value: 180 },
        { label: 'Cuatro Horas', value: 210 },
        { label: 'Cuatro Horas y Media', value: 240 },
        { label: 'Cinco Horas', value: 270 },
        { label: 'Cinco Horas y Media', value: 300 },
    ]


    return <Form name="nueva_cita_admin" layout="vertical" onFinish={onFinish} onFinishFailed={onFinishFailed} autoComplete="off"
        initialValues={props.cita ? props.cita : { isOnline: false, tratamiento: 'Sin servicio', fecha_hora: props.fecha_hora, duracion: 60 }}
        style={{ marginTop: 16 }}>

        {errorMessage && <Alert message={errorMessage} type="error" showIcon style={{ marginBottom: 16 }} />}

        <Form.Item label={<b>Paciente</b>} name="usuario" rules={[{ required: true, message: 'Selecciona Usuario' }]} >
            <Select
                options={pacientes}
                onChange={handlePatientChange}
                onSearch={(val) => {
                    clearTimeout(searchDebounce.current)
                    searchDebounce.current = setTimeout(() => fetchPacientes(val), 400)
                }}
                showSearch
                filterOption={false}
                loading={pacientesLoading}
                notFoundContent={pacientesLoading ? <Spin size="small" /> : 'Sin resultados'}
                placeholder="Buscar paciente..."
            />
        </Form.Item>

        {
            medicos.length > 1 ?
                <Form.Item label={<b>Médico</b>} name="medico" rules={[{ required: true, message: 'Selecciona Medico' }]} >
                    <Select options={medicos} onChange={handleMedicochange} />
                </Form.Item>
                :
                <Form.Item label={<b>Médico</b>}>
                    <Typography.Text strong style={{ fontSize: '16px', color: '#1677ff' }}>{medicos[0]?.name}</Typography.Text>
                </Form.Item>
        }

        <div style={{ display: 'flex', gap: '16px' }}>
            <Form.Item label={<b>Fecha y Hora</b>} name="fecha_hora" rules={[{ required: false, message: 'Selecciona Fecha y Hora' }]} style={{ flex: 1 }}>
                <DatePicker showTime format="DD/MM/YYYY HH:mm" use12Hours={true} style={{ width: '100%' }} />
            </Form.Item>

            <Form.Item label={<b>Duración</b>} name="duracion" rules={[{ required: true, message: 'Selecciona la duracion de la cita' }]} style={{ flex: 1 }}>
                <Select options={timeOptions} />
            </Form.Item>
        </div>

        <Form.Item label={<b>Servicio</b>} name="servicio" rules={[{ required: true, message: 'Selecciona Servicio' }]} >
            <Select options={servicios} onChange={handleServicioChange} labelInValue />
        </Form.Item>

        <Form.Item label={<b>¿Consulta en línea? (Videollamada)</b>} name="isOnline" >
            <Switch onChange={onSwitch} checkedChildren="Sí" unCheckedChildren="No" />
        </Form.Item>

        <Form.Item label={<b>Comentarios adicionales</b>} name="comentarios" rules={[{ required: false, message: 'Ingresa Comentarios' }]} >
            <Input.TextArea rows={2} placeholder="Escribe aquí cualquier detalle extra..." />
        </Form.Item>

        {
            props.cita && <div style={{ textAlign: 'right', marginTop: '24px' }}>
                <Button type="primary" htmlType="submit" form='nueva_cita_admin' disabled={!enableCreateCita} icon={<SaveOutlined />}>
                    Guardar Cambios
                </Button>
            </div>
        }

    </Form>
}

export default function CreateCita(props) {

    const handCreateleOk = () => { props.setIsModalOpen(false) }
    const handCreateleCancel = () => { props.setIsModalOpen(false) }

    return (
        <Modal
            title={
                <Space>
                    <PlusCircleOutlined style={{ color: '#1677ff', fontSize: '20px' }} />
                    <span style={{ fontSize: '18px', fontWeight: 600 }}>Agendar Nueva Cita</span>
                </Space>
            }
            open={props.isOpenModal}
            onOk={handCreateleOk}
            onCancel={handCreateleCancel}
            destroyOnClose
            width={600}
            centered
            footer={[
                <Button key="cancel" onClick={handCreateleCancel} icon={<CloseCircleOutlined />}>Cancelar</Button>,
                <Button key="save" type="primary" htmlType="submit" form='nueva_cita_admin' icon={<SaveOutlined />}>
                    Guardar
                </Button>
            ]}
        >
            <CreateCitaForm {...props} />
        </Modal>
    )
}
